
export interface ActivityModule {
    moduleId: string;
    customData?: any;
};

export enum ModuleType {
  PARTICIPANT = 'participant',
  ACTIVITY = 'activity'
}

export interface ModuleConfig {
  id: string;
  type: ModuleType;
  name: string;
  description?: string;
  initialState?: Record<string, any>;
  requiresJoin?: boolean;
  /** Set to true if the activity has its own PTT - hides the room's PTT button */
  disablePTT?: boolean;
}




export const MAIN_VIDEO_MODULE_ID = 'main-video' as const;

export enum ActivityState {
    INACTIVE = 'inactive',
    ACTIVE_FOCUSED = 'active_focused',
    ACTIVE_BACKGROUND = 'active_background',
    PAUSED = 'paused'
}



